import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import { InputLabel } from "@mui/material";
import * as dayjs from "dayjs";
import "dayjs/locale/de";

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["label", "onClick", "value", "valueLabelFormat", "valueLabelDisplay"].includes(prop),
})(({
    theme, label, onClick, value, valueLabelFormat, valueLabelDisplay,
}) => ({

    "& .Mui-disabled fieldset": {
        backgroundColor: theme.palette?.action?.disabledBackground,
    },
    "& .Mui-disabled": {
        color: `${theme.palette.grey.primary} !important`,
        "-webkit-text-fill-color": "initial",
    },
    "& .MuiOutlinedInput-root": {
        background: "none",
        fontSize: 12,
        margin: 0,
        padding: 0,
        "& .Mui-disabled": {
            cursor: (onClick && value) && "pointer",
            color: (onClick && value) && "#4594AD",
            textDecoration: (onClick && value) && "underline",
            "&:hover": {
                color: (onClick && value) && "inherit",
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            "&  legend": {
                border: "none",
            },
            top: 0,
            ...label ? {
                height: 24,
                marginTop: 12,
            } : {
                height: 24,
            },
        },
        "& .MuiOutlinedInput-input": {
            // paddingTop: 4,
            // paddingBottom: 2,
            paddingLeft: 4,
            // paddingRight: 3,
        },
        "& .MuiIconButton-root": {
            minWidth: 16,
            marginRight: 4,
        },
        ...label ? {
            marginTop: 2,
            "& .MuiSelect-iconOutlined": {
                marginTop: 7,
            },
            // "& .MuiOutlinedInput-input": {
            //     marginTop: 13,
            // },
        } : {
            "& .MuiSelect-iconOutlined": {
                marginTop: "1px!important",
            },
            "&>*:not(.MuiOutlinedInput-notchedOutline):not(.MuiSelect-select)": {
                marginTop: 2,
            },
            "& .MuiSelect-select": {
                marginTop: 0.75,
            },
        },
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },
    "& .MuiSelect-select": {
        paddingRight: "10px!important",
    },
    "& .MuiSelect-icon": {
        marginRight: -4,
    },
    ...label ? {
        marginTop: (valueLabelFormat || valueLabelDisplay === "on") && "15px",
    } : {
        height: 24,
    },
}));
export default function CustomDatePicker(props) {
    const {
        label,
        disabled,
        error,
        name,
        value,
        required,
        onChange,
        fullWidth,
        sx,
    } = props;

    return (
        <StyledFormControl
            label={label}
            variant="outlined"
            disabled={disabled}
            required={required}
            fullWidth={fullWidth}
            sx={sx}
            error={error}
        >
            {label ? (
                <InputLabel>
                    {label}
                </InputLabel>
            ) : null}
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
                <DemoContainer components={["DatePicker"]}>
                    <DesktopDatePicker
                        name={name}
                        value={value ? dayjs(value) : null}
                        onChange={(e) => onChange(dayjs(e).locale("de").format())}
                        disabled={disabled}
                        calendarStartDay={1}
                    />
                </DemoContainer>
            </LocalizationProvider>
        </StyledFormControl>

    );
}
